var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9a4caabc3b549b0511e5b26836a0ffebe3ca373c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@humanloop"]={id:"9a4caabc3b549b0511e5b26836a0ffebe3ca373c"};
      